import { translate } from "app/filters/i18nFilter";
import { CLOSE, ERROR_MSG } from "app/pages/sales-intelligence/modules/enrichment/utils/i18n/modal.texts";
import { ErrorContainer } from "../../containers/EnrichmentCsvContainer/style";

import { Header } from "./Header";

export const ErrorView = ({ onClose }: { onClose(): void }) => (
    <>
        <Header
            tooltipContent={translate(CLOSE)}
            onClick={onClose}
            title="Error"
            iconName="close"
            iconSize="xs"
        />
        <ErrorContainer>
            <div>{translate(ERROR_MSG)}</div>
        </ErrorContainer>
    </>
);
